import styled from 'styled-components';
import WaAvatar from '@web.awesome.me/webawesome-pro/dist/react/avatar';

export const Avatar = styled(WaAvatar)`
  html.wa-dark & {
    --wa-color-neutral-fill-normal: var(--bg-4);
    --wa-color-neutral-on-normal: var(--title-text);
  }
`;
